import { createSlice } from "@reduxjs/toolkit";
import { checkToggleAudio } from "../utils/AudioUtils";

interface Audio {
  audioModalMessageAlreadyShown: boolean;
  toggleAllAudios: boolean;
  isBackgroundAudioEnabled: boolean;
  areAudioEffectsEnabled: boolean;
  audioEffectToBePlayed: number;
  isMute: boolean;
}

const initialState: Audio = {
  audioModalMessageAlreadyShown: false,
  toggleAllAudios: false,
  isBackgroundAudioEnabled: false,
  areAudioEffectsEnabled: false,
  audioEffectToBePlayed: 0,
  isMute: false,
};

export const audioSlice = createSlice({
  name: "audio",
  initialState,
  reducers: {
    disableAudioModalMessage: (state, { payload }) => {
      state.audioModalMessageAlreadyShown = payload;
    },
    setToggleAllAudios(state) {
      state.toggleAllAudios = !state.toggleAllAudios;
      state.isBackgroundAudioEnabled = state.toggleAllAudios;
      state.areAudioEffectsEnabled = state.toggleAllAudios;
    },
    toggleBackgroundAudio(state) {
      state.isBackgroundAudioEnabled = !state.isBackgroundAudioEnabled;
      state.toggleAllAudios = checkToggleAudio(
        state.isBackgroundAudioEnabled,
        state.areAudioEffectsEnabled
      );
    },
    toggleAudioEffects(state) {
      state.areAudioEffectsEnabled = !state.areAudioEffectsEnabled;
      state.toggleAllAudios = checkToggleAudio(
        state.isBackgroundAudioEnabled,
        state.areAudioEffectsEnabled
      );
    },
    playAudioEffect(state, { payload }) {
      if (state.areAudioEffectsEnabled) {
        state.audioEffectToBePlayed = payload;
      }
    },
    setMute(state, { payload }) {
      state.isMute = payload;
    },
  },
});

export const {
  disableAudioModalMessage,
  setToggleAllAudios,
  toggleBackgroundAudio,
  toggleAudioEffects,
  playAudioEffect,
  setMute,
} = audioSlice.actions;

export default audioSlice.reducer;
